import axios from 'axios';
import qz from 'qz-tray';
import { SENTO_QZ_SIGN_ENDPOINT } from '../../app/constants/endpoints';

qz.security.setCertificatePromise((resolve, reject) => {
  fetch('/digital-certificate.txt', {
    cache: 'no-store',
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error('Không tải được QZ certificate');
      }

      return response.text();
    })
    .then(resolve)
    .catch(reject);
});

qz.security.setSignatureAlgorithm('SHA512');

qz.security.setSignaturePromise((toSign) => {

  return (resolve, reject) => {
    axios
      .post(
        SENTO_QZ_SIGN_ENDPOINT,
        { request: toSign },
        { responseType: 'text' }
      )
      .then((response) => {
        return resolve(response.data)
      })
      .catch(reject);
  };
});

export default qz;